/**
 * Reclaim Journeys — Absorption Engine visual tokens (v4 NAVY DARK MODE).
 *
 * Direction (per user brief — appeal to 16-20 age group, less luxury retreat):
 *   - Deep navy / cool dark base (matches Configure Session aesthetic)
 *   - Glass cards: rgba(255,255,255,0.06) + soft blur
 *   - White primary text, reduced-opacity white for secondary
 *   - ONE accent: blue (#4DA3FF) for primary actions/progress/highlights
 *   - Gold ONLY for completion / rewards / milestones (sparingly)
 */
export const JOURNEY_PALETTE = {
  // ─── Reclaim DNA (warm tokens kept available, used sparingly) ──
  warmSand:      "#F4F1EA",
  softCream:     "#FAF7F2",

  // ─── Gold reserved for ACHIEVEMENTS only ──────────
  accentGold:    "#D4B87E",   // milestone gold (only on completed states)
  accentAmber:   "#E6C27A",
  accentRust:    "#B8806C",
  accentSage:    "#7FA58A",
  accentSageSoft: "#9BB8A6",

  // ─── PRIMARY ACCENT (cool blue) ───────────────────
  accentBlue:    "#4DA3FF",
  accentBlueDeep: "#2E7BD6",
  accentBlueSoft: "rgba(77,163,255,0.18)",
  accentTeal:    "#4FD1C5",

  // ─── Cool layer extras ────────────────────────────
  softSky:       "#E9F0F4",
  paleBlue:      "#DCEEF8",
  gentleGreen:   "#E7F3EC",
  paleLavender:  "#EFEAF6",
  blueGrey:      "#D4DDE3",
  coolMist:      "#F0F4F7",

  // ─── Backgrounds (NAVY DARK) ──────────────────────
  bgBase:        "#0D1B2A",
  bgCard:        "rgba(255,255,255,0.06)",   // glass card
  bgGlass:       "rgba(255,255,255,0.08)",
  bgGlassFloat:  "rgba(255,255,255,0.10)",   // slightly more lifted

  // Primary deep-navy gradient
  bgWash:        "linear-gradient(180deg, #0D1B2A 0%, #142434 50%, #1B2A3A 100%)",
  bgWashSky:     "linear-gradient(180deg, #0D1B2A 0%, #16263A 100%)",
  // Arrival keeps a warm dawn glow over deep navy
  bgMorningWash: "linear-gradient(180deg, #0D1B2A 0%, #1A2840 60%, #2B3450 100%)",

  // ─── Text (WHITE on navy) ─────────────────────────
  textPrimary:   "#FFFFFF",
  textSecondary: "rgba(255, 255, 255, 0.75)",
  textMuted:     "rgba(255, 255, 255, 0.50)",
  textWhisper:   "rgba(255, 255, 255, 0.32)",

  // ─── Lines ────────────────────────────────────────
  hairline:      "rgba(255, 255, 255, 0.10)",
  hairlineSoft:  "rgba(255, 255, 255, 0.06)",

  // ─── Surfaces — DARK MODE shadows ─────────────────
  surfaceLifted: "0 14px 40px rgba(0, 0, 0, 0.42), 0 1px 2px rgba(0, 0, 0, 0.18)",
  surfaceFloat:  "0 30px 70px rgba(0, 0, 0, 0.55), 0 1px 2px rgba(0, 0, 0, 0.22)",
  coolShadowSm:  "rgba(0, 0, 0, 0.18)",
  coolShadowMd:  "rgba(0, 0, 0, 0.30)",
  coolShadowLg:  "rgba(0, 0, 0, 0.45)",
};

// ─── Typography ───────────────────────────────────
export const JOURNEY_FONT_HEAD  = "'Playfair Display', Georgia, serif";
export const JOURNEY_FONT_BODY  = "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif";
export const JOURNEY_FONT_LABEL = "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif";
export const JOURNEY_FONT_CLARITY = JOURNEY_FONT_BODY;
